import { render, staticRenderFns } from "./RemainingBalancePartners.vue?vue&type=template&id=b217f790&scoped=true&"
import script from "./RemainingBalancePartners.vue?vue&type=script&lang=js&"
export * from "./RemainingBalancePartners.vue?vue&type=script&lang=js&"
import style0 from "./RemainingBalancePartners.vue?vue&type=style&index=0&id=b217f790&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b217f790",
  null
  
)

export default component.exports